// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"71":"2ca17cbb","189":"97fd0a8f","806":"36142ecb"}[chunkId] + ".js";
};